/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type LoadAllCommentsConfig_formValues = {
    readonly loadAllComments: boolean;
    readonly " $refType": "LoadAllCommentsConfig_formValues";
};
export type LoadAllCommentsConfig_formValues$data = LoadAllCommentsConfig_formValues;
export type LoadAllCommentsConfig_formValues$key = {
    readonly " $data"?: LoadAllCommentsConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"LoadAllCommentsConfig_formValues">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadAllCommentsConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "loadAllComments",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '2c3a596f86fbc9f2f290fc68714e85d7';
export default node;
